<template>
    <div class="carPark">
    <router-view class="aaaa"></router-view>
    </div>
</template>
<script>
export default {
    name: 'parkMain'
}
</script>
<style scrop>
.carPark {
    width: 100%;
    height: 100%;
    display: flex;
}
</style>
